import React from "react";
import { contactInfo } from "../mock";

const LegalMentions = () => {
  return (
    <section id="mentions" className="bg-[#E9E1D4] py-24 md:py-28 border-t border-neutral-900/10" data-nav-theme="light">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-4">
          <span className="h-px w-10 bg-[#9F8B76]" />
          <span className="uppercase tracking-[0.3em] text-[11px] text-neutral-500">Informations légales</span>
        </div>
        <h2
          className="font-display uppercase text-neutral-900 leading-[0.95]"
          style={{ fontSize: "clamp(30px, 4vw, 60px)" }}
        >
          Mentions légales
        </h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-10 text-neutral-700 text-[14px] leading-relaxed">
          <div>
            <h3 className="text-neutral-900 font-medium mb-2 uppercase text-[11px] tracking-widest">Éditeur du site</h3>
            <p>
              Maison Labroca — SCI (Société Civile Immobilière)<br />
              SIREN 502 799 901<br />
              {contactInfo.location}<br />
              Directeur de la publication : Antonio Labroca<br />
              Contact&nbsp;:{" "}
              <a
                href={`mailto:${contactInfo.email}`}
                className="underline decoration-neutral-300 underline-offset-4 hover:text-[#9F8B76] hover:decoration-[#9F8B76] transition-colors break-all"
              >
                {contactInfo.email}
              </a>
            </p>
          </div>
          <div>
            <h3 className="text-neutral-900 font-medium mb-2 uppercase text-[11px] tracking-widest">Hébergement</h3>
            <p>
              OVH SAS<br />
              2 rue Kellermann<br />
              59100 Roubaix — France<br />
              RCS Lille Métropole 424 761 419 00045
            </p>
          </div>
          <div>
            <h3 className="text-neutral-900 font-medium mb-2 uppercase text-[11px] tracking-widest">Propriété intellectuelle</h3>
            <p>
              L'ensemble des contenus (textes, images, vidéos) présents sur ce site est protégé et ne peut être reproduit sans autorisation préalable.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LegalMentions;
